// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__4PjWt","validationTips":"StatementDescriptor_validationTips__NzWl9"};